import { Link, useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { NotificationBell } from "@/components/notifications/notification-bell"
import { useAuth } from "@/hooks/use-auth"
import { useNotifications } from "@/hooks/use-notifications"

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { 
    notifications, 
    handleNotificationClick, 
    clearAll 
  } = useNotifications();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleDashboard = () => {
    if (!user) return;

    const dashboardRoutes = {
      admin: '/admin/dashboard',
      property_owner: '/owner/dashboard',
      property_manager: '/manager/dashboard',
      flex_helper: '/helper/dashboard'
    };

    const route = dashboardRoutes[user.role];
    if (route) {
      navigate(route);
    }
  };

  return (
    <header className="fixed top-0 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 z-50">
      <nav className="container flex h-32 items-center justify-between">
        <Link to="/" className="flex items-center">
          <img 
            src="/logo.svg" 
            alt="FlexHelp" 
            className="h-48 w-auto"
            style={{ fill: '#53253e' }} 
          />
        </Link>
        
        <div className="flex items-center gap-6">
          <div className="hidden md:flex items-center gap-6">
            <Link to="/about">
              <Button variant="ghost">About</Button>
            </Link>
            <Link to="/services">
              <Button variant="ghost">Services</Button>
            </Link>
            <Link to="/contact">
              <Button variant="ghost">Contact</Button>
            </Link>
          </div>
          
          {user ? (
            <div className="flex items-center gap-4">
              <NotificationBell
                notifications={notifications}
                onNotificationClick={handleNotificationClick}
                onClearAll={clearAll}
              />
              <Button 
                variant="ghost"
                onClick={handleDashboard}
              >
                Dashboard
              </Button>
              <Button onClick={handleLogout}>Sign Out</Button>
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <Link to="/login">
                <Button variant="ghost">Sign In</Button>
              </Link>
              <Link to="/register">
                <Button>Get Started</Button>
              </Link>
            </div>
          )}
        </div>
      </nav>
    </header>
  )
}